module.exports = __webpack_public_path__ + "img/ss-2.404da0cb.svg";